


















import { Component, Vue } from 'vue-property-decorator';
import FilterTable from '@/components/tables/filter-table.vue';
import { VirtualTableState } from '@/typings/datatable';
import SecondaryNav from '@/components/navbars/secondary-nav.vue';
import { FaultsApi, Product, ProductsApi } from '@/api';
import moment from 'moment';

@Component({
	components: {
		SecondaryNav,
		FilterTable,
	},
})
export default class FaultsList extends Vue {
	public faults: any[] = [];
	public renderKey = 0;
	public loading = false;

	private api: ProductsApi;

	constructor() {
		super();
		this.api = new ProductsApi();
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', 'products-datatable');
	}

	public clickTable(item: Product, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: 'faults.view',
				params: { productId: item.id },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: 'faults.view',
				params: { productId: item.id },
			} as any);
		}
	}

	public async getFaultTypeList() {
		this.loading = true;
		try {
			const { data } = await new FaultsApi().getFaultTypes();
			if (data.data) {
				data.data.forEach(faultType =>
					this.faultsState.filterFields.push({
						checked: false,
						text: faultType.split(/(?=[A-Z])/).join(' '),
						value: faultType,
					}),
				);
			}
		} catch (e) {
			console.log(e);
		}
	}

	public async load() {
		this.loading = true;
		try {
			const { data } = await new ProductsApi().productsGetFaults();
			if (data.data) {
				data.data.forEach((fault: any) => {
					fault.productName = `${fault.productName} ${
						fault.supplierNumber ? `(${fault.supplierNumber})` : ''
					}`;
					this.faults.push(fault);
				});
			}
		} catch (e) {
			console.log(e);
		}

		const sortOrder = ['new', 'rebooting', 'monitor', 'repair', 'resolved'];

		this.faults = this.faults.sort((a: any, b: any) => {
			if (a.faultStatus === b.faultStatus) {
				if (b.faultDate === null) {
					return -1;
				}
				return moment.utc(a.faultDate).isAfter(moment.utc(b.faultDate)) ? -1 : 1;
			}
			return sortOrder.indexOf(a.faultStatus) - sortOrder.indexOf(b.faultStatus);
		});
		this.loading = false;

		this.renderKey += 1;
	}

	public created() {
		this.load();
		this.getFaultTypeList();
	}
}
